const getReduxKey = (prefix: string, id?: string) => `${prefix}-${id}`

export default getReduxKey
